import type { Feature } from '@luna/gatekeeper';

export const cardClosingInfoScreen: Feature = {
    enabled: true,
};
